 import React from 'react'
 import App from './App.css';
 
 function EditorInfo() {
 return(
<div  className="App">
<h3 className="">Peer Review Co-ordinator</h3>
                    <p className="">
                  <strong>Dr. SO Omorodion </strong><br/>School of Technology Education,  Federal College of  Technical Education Asaba
                    </p>
                  <p className="">
                        <span className="">Email </span> : <u>jtvetuniben.fcet@gmail.com</u>
                    </p>
              </div>
 )
}
export default EditorInfo;